<template>
  <el-dialog class="dialog-container" :visible="dialogVisible" @close="close">
    <!-- SLOT TITLE -->
    <div slot="title" class="dialog-title">
      <div class="title-name">Download receipt preview</div>
    </div>
    <!-- PREVIEW CONTENT -->
    <div class="bg_d8d8d8 pd10">
      <div id="content-to-print" class="flex_row flex_center" ref="content">
        <div class="receipt_bg" ref="receipt_content">
          <div class="w100 d_flex flex_center">
            <img
              class="receipt_logo"
              src="../../../assets/img/login_logo.png"
            />
            <div class="d_flex_column flex_center mgl20">
              <strong class="font32 black">Receipt</strong>
              <div class="mgt10 c999">ALM RESOURCES SDN. BHD.</div>
            </div>
          </div>

          <div class="divider mgt16" />
          <div class="w100 mgt16 d_flex d_between">
            <div class="w120px">Order no</div>
            <div>{{ orderData.orderNo ? orderData.orderNo : '-' }}</div>
          </div>

          <div class="divider mgt10" />
          <div class="w100 mgt16 d_flex d_between">
            <div class="w120px">Order time</div>
            <div>{{ orderData.orderTime ? orderData.orderTime : '-' }}</div>
          </div>

          <div class="divider mgt10" />
          <div class="w100 mgt16 d_flex d_between">
            <div class="w120px">Pick-up location</div>
            <div>
              {{
                orderData
                  ? orderData.originLocation && orderData.originLocation.address
                    ? orderData.originLocation.address
                    : '-'
                  : '-'
              }}
            </div>
          </div>

          <div class="divider mgt10" />
          <div class="w100 mgt16 d_flex d_between">
            <div class="w120px">Pick-up time</div>
            <div>
              {{ orderData.departureTime ? orderData.departureTime : '-' }}
            </div>
          </div>

          <div class="divider mgt10" />
          <div class="w100 mgt16 d_flex d_between">
            <div class="w120px">Drop-off location</div>
            <div>
              {{
                orderData
                  ? orderData.destinationLocation &&
                    orderData.destinationLocation.address
                    ? orderData.destinationLocation.address
                    : '-'
                  : '-'
              }}
            </div>
          </div>

          <div class="divider mgt10" />
          <div class="w100 mgt16 d_flex d_between">
            <div class="w120px">Drop-off time</div>
            <div>
              {{ orderData.completeTime ? orderData.completeTime : '-' }}
            </div>
          </div>

          <div class="divider mgt10" />
          <div class="w100 mgt16 d_flex d_between">
            <div class="w120px">Order amount</div>
            <div>
              {{ orderData.totalAmount ? 'MYR ' + orderData.totalAmount : '-' }}
            </div>
          </div>

          <div class="divider mgt10" />
          <div class="w100 mgt16 d_flex d_between">
            <div class="w120px">Payment method</div>
            <div>{{ orderData.payChannel ? orderData.payChannel : '-' }}</div>
          </div>

          <div class="divider mgt10" />
          <div class="w100 mgt16 d_flex d_between">
            <div class="w120px">Driver name</div>
            <div>{{ orderData.driver ? orderData.driver.name : '-' }}</div>
          </div>

          <div class="divider mgt10" />
          <div class="w100 mgt16 d_flex d_between">
            <div class="w120px">Driver mobile</div>
            <div>{{ orderData.driver ? orderData.driver.mobile : '-' }}</div>
          </div>

          <div class="divider mgt10" />
          <div class="w100 mgt16 d_flex d_between">
            <div class="w120px">Vehicle type</div>
            <div>
              {{
                orderData
                  ? orderData.vehicleType && orderData.vehicleType.name
                    ? orderData.vehicleType.name
                    : '-'
                  : '-'
              }}
            </div>
          </div>

          <div class="divider mgt10" />
          <div class="w100 mgt16 d_flex d_between">
            <div class="w140px">Vehicle license plate</div>
            <div>
              {{
                orderData
                  ? orderData.vehicle && orderData.vehicle.licensePlate
                    ? orderData.vehicle.licensePlate
                    : '-'
                  : '-'
              }}
            </div>
          </div>

          <div v-if="orderData.payChannel === 'CASH'" />
          <div v-else>
            <div class="divider mgt10" />
            <div class="w100 mgt16 d_flex d_between">
              <div class="w120px">Account no</div>
              <div>{{ orderData.accountNo ? orderData.accountNo : '-' }}</div>
            </div>

            <div class="divider mgt10" />
            <div class="w100 mgt16 d_flex d_between">
              <div class="w120px">Card type</div>
              <div>{{ orderData.cardType ? orderData.cardType : '-' }}</div>
            </div>

            <div class="divider mgt10" />
            <div class="w100 mgt16 d_flex d_between">
              <div class="w120px">Issuer bank</div>
              <div>{{ orderData.issuerBank ? orderData.issuerBank : '-' }}</div>
            </div>

            <div class="divider mgt10" />
            <div class="w100 mgt16 d_flex d_between">
              <div class="w120px">Tran ref</div>
              <div>{{ orderData.tranRef ? orderData.tranRef : '-' }}</div>
            </div>

            <div class="divider mgt10" />
            <div class="w100 mgt16 d_flex d_between">
              <div class="w120px">Reference no</div>
              <div>
                {{ orderData.referenceNo ? orderData.referenceNo : '-' }}
              </div>
            </div>
          </div>
          <div class="w100 flex_row flex_center c999 mgt20">
            Visit almgo.my/tnc.php for terms and conditions
          </div>
        </div>
      </div>
    </div>
    <!-- SLOT FOOTER -->
    <span slot="footer">
      <el-button class="cancel" @click="dialogVisible = false"
        >Cancel</el-button
      >
      <el-button class="confirm" @click="confirm">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { orderTripReceiptsDetail } from '@/api/orders/orderList'

export default {
  props: {},
  data() {
    return {
      dialogVisible: false,
      orderData: {}
    }
  },
  mounted() {
    this.dialogVisible = false
  },
  methods: {
    show(id) {
      this.dialogVisible = true
      console.log('order ID:', id)
      this.getOrderTripReceiptsDetail(id)
    },
    async getOrderTripReceiptsDetail(id) {
      const params = { orderId: id }
      console.log('orderTripReceiptsDetail params:', params)
      await orderTripReceiptsDetail(params).then((res) => {
        console.log('orderTripReceiptsDetail res:', res.data)
        this.orderData = res.data
      })
    },
    close() {
      this.dialogVisible = false
    },
    confirm() {
      this.printToPDF()
      this.close()
    },
    async printToPDF() {
      const content = this.$refs.content
      const canvas = await html2canvas(content)
      const imgData = canvas.toDataURL('image/png')
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      })
      const imgProps = doc.getImageProperties(imgData)
      const pdfWidth = doc.internal.pageSize.getWidth()
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width
      doc.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight)
      doc.save(this.orderData.orderNo + '.pdf')
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-container {
  .dialog-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;

    .title-name {
      display: flex;
      align-items: center;
      font-size: 20px;
      font-weight: 500;
      color: #000000;
      // &::before {
      //     width: 26px;
      //     height: 26px;
      //     content: "";
      //     background: url("../../assets/image/home/warn-icon.png")
      //         no-repeat;
      //     background-size: 100% 100%;
      //     margin-right: 10px;
      // }
    }

    .right-btn {
      height: 40px;
      cursor: pointer;
    }

    .right-btn .el-icon {
      margin-right: 10px;
      height: 100%;
    }

    .right-btn .el-icon:hover {
      color: #fff000;
    }
  }

  .cancel {
    width: 154px;
    height: 46px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e3e3e3;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    text-align: center;
    font-style: normal;
  }

  .confirm {
    width: 154px;
    height: 46px;
    background: #000000;
    border-radius: 8px;
    border: 1px solid #e3e3e3;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    text-align: center;
    font-style: normal;
  }

  .receipt_bg {
    width: 350px;
    background-color: #ffffff;
    padding: 14px;
  }

  .receipt_logo {
    width: 48px;
    height: 48px;
  }
}
</style>
